var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4530.1,5007.9C3375.4,4889,2341.7,4400,1530.4,3588.6C751.6,2809.9,287.5,1860.5,124.4,723.1c-32.6-226.3-32.6-982,0-1208.3c163-1137.4,629.1-2086.8,1405.9-2865.5c778.7-776.8,1728.1-1242.9,2865.5-1405.9c226.3-32.6,982-32.6,1208.3,0c939.8,134.3,1779.9,491,2474.2,1053c987.8,797.9,1611.1,1916.1,1797.2,3218.4c32.6,226.3,32.6,982,0,1208.3C9741.3,1663,9396,2482,8839.8,3178.2c-281.9,351-725,763.4-1081.8,1003.1c-623.3,420-1298.5,680.9-2067.6,799.8C5448.8,5017.5,4775.6,5034.8,4530.1,5007.9z M5364.4,3782.4c1114.3-117,2106-717.3,2715.9-1651.4c709.7-1081.7,794.1-2478,222.5-3632.7c-86.3-176.4-245.5-439.2-283.9-469.9c-24.9-23-354.8,299.2-2579.7,2524.1c-1402.1,1402.1-2549,2558.6-2549,2570.1c0,26.9,351,235.9,556.2,331.8C4046.7,3734.4,4718,3849.5,5364.4,3782.4z M4578-312.6c2441.6-2441.6,2558.6-2560.5,2522.2-2589.3c-71-53.7-343.3-216.7-479.5-282c-1507.5-748-3354.6-356.7-4436.3,934.1c-960.9,1147-1137.4,2756.2-446.9,4068.1c95.9,180.3,251.2,429.6,270.4,429.6C2013.7,2248,3170.2,1095.2,4578-312.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbort);
export default __webpack_public_path__ + "static/media/abort.2de971bcda57e84030af7fa118373ee4.svg";
export { ForwardRef as ReactComponent };